import { ActivatedRoute } from "@angular/router";
import { Component, OnInit } from "@angular/core";
import { AbstractControl, FormGroup, FormBuilder, Validators, FormControl } from "@angular/forms";
import { Router } from "@angular/router";
import { switchMap, debounceTime, tap } from "rxjs/operators";
import { MatDialog } from '@angular/material';
import { STUDENT_FILER_OPTIONS } from 'src/app/dummy/status';
import { TrainingStore } from 'src/app/stores/training/training.store';
import { APPS } from 'src/app/dummy/app';
import { AddTrainingStudentComponent } from '../add-training-student/add-training-student.component';
import { AddTrainingAdminssionComponent } from '../add-training-adminssion/add-training-adminssion.component';

@Component({
  selector: 'app-training-student',
  templateUrl: './training-student.component.html',
  styleUrls: ['./training-student.component.scss']
})
export class TrainingStudentComponent implements OnInit {
  formFocus: boolean;
  form: FormGroup;
  search: AbstractControl;
  searchType: AbstractControl;

  filterBy = STUDENT_FILER_OPTIONS;
  loading = false;
  SELECTED_STUDENT: any;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private dialog: MatDialog,
    public store: TrainingStore
  ) { }

  async ngOnInit() {
    this.form = this.fb.group({
      searchType: [this.filterBy[0], [Validators.required]],
      search: [null]
    });
    this.search = this.form.controls['search'];
    this.searchType = this.form.controls['searchType'];

    if (this.store.filterType) {
      this.form.patchValue({ searchType: this.store.filterType });
    }
    await this.store.fetchStudent();
    this.search.valueChanges.pipe(
      debounceTime(APPS.DEBOUNCE_TIME),
      tap(() => (this.loading = true)),
      switchMap(value => this.store.fetchFilterStudent(this.form.value.searchType.key, value))
    ).subscribe(results => {
      this.store.data = results;
      this.loading = false;
    });

  }

  displayItem(item: any): string {
    if (this.searchType && this.searchType.value) {
      const { key } = this.searchType.value;
      return item ? item[key] : item;
    }
    return item ? item.fullName : item;
  }

  compareObjects(o1: any, o2: any): boolean {
    if (o2) {
      return o1.key === o2.key;
    }
  }

  _onFocus(yes) {
    this.formFocus = yes;
  }

  _selectionChange(event) {
    const { value } = event;
    this.store.filterType = value;
  }


  _onSelectedInstructor() {
    if (!this.SELECTED_STUDENT) return;
    const dialogRef = this.dialog.open(AddTrainingAdminssionComponent, {
      data: { SELECTED_STUDENT: this.SELECTED_STUDENT },
      panelClass: "register-test-overlay-panel",
      width: "35vw",
      height: "100vh",
      disableClose: true,
      role: "dialog"
    });
    dialogRef.updatePosition({ top: "0", right: "0", bottom: "0" });
    dialogRef.afterClosed().subscribe(result => { });
  }

  createStudent(item?: any) {
    const dialogRef = this.dialog.open(AddTrainingStudentComponent, {
      data: { STUDENT: item || null },
      panelClass: "register-test-overlay-panel",
      width: "35vw",
      height: "100vh",
      disableClose: true,
      role: "dialog"
    });
    dialogRef.updatePosition({ top: "0", right: "0", bottom: "0" });
    dialogRef.afterClosed().subscribe(result => { });
  }

  _onSearchInstructor(item) {
    this.SELECTED_STUDENT = item;
  }



}
